var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4H8C6.13616 4 4.57006 5.27477 4.12602 7H18.874C18.4299 5.27477 16.8638 4 15 4ZM4 15V9H19V11.3414C18.3744 11.1203 17.7013 11 17 11C13.6863 11 11 13.6863 11 17C11 17.7013 11.1203 18.3744 11.3414 19H8C5.79086 19 4 17.2091 4 15ZM21 8V12.5278C22.2275 13.6264 23 15.223 23 17C23 20.3137 20.3137 23 17 23C15.223 23 13.6264 22.2275 12.5278 21H8C4.68629 21 2 18.3137 2 15V8C2 4.68629 4.68629 2 8 2H15C18.3137 2 21 4.68629 21 8ZM17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21ZM18.0009 16C18.0009 15.4477 17.5532 15 17.0009 15C16.4486 15 16.0009 15.4477 16.0009 16V16.8818L15.5532 17.1054C15.0591 17.3521 14.8586 17.9527 15.1054 18.4468C15.3521 18.9409 15.9527 19.1414 16.4468 18.8946L17.4477 18.3948C17.7867 18.2255 18.0009 17.8791 18.0009 17.5002V16Z",
    fill: "#303C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.c74c589b791a4f58822b5644505a06c6.svg";
export { ForwardRef as ReactComponent };